import { render } from "./SearchView.vue?vue&type=template&id=3ccc003c&scoped=true&ts=true"
import script from "./SearchView.vue?vue&type=script&lang=ts"
export * from "./SearchView.vue?vue&type=script&lang=ts"

import "./SearchView.vue?vue&type=style&index=0&id=3ccc003c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ccc003c"]])

export default __exports__